import {createSelector} from 'reselect'
import * as EntitiesSelectors from '../../../entities/selectors'
import selectorsGenerator from '../hierarchyAssignmentsEditor/selectorsGenerator'
import {getFullUserInfo} from '../../../panels/user/userData/selectors'
import {needMoreEntities} from '../hierarchyAssignmentsEditor/utils'

const getManagementAssignmentsEditorState = state => state.userManagement.createManagementAssignmentsEditor
const hierarchyAssignmentsEditorSelectors = selectorsGenerator(getManagementAssignmentsEditorState)

export const showEditor = createSelector(
    getManagementAssignmentsEditorState,
    (state) => state.show
)

export const isLoaded = hierarchyAssignmentsEditorSelectors.isLoaded

export const needMoreCustomers = createSelector(
    showEditor,
    hierarchyAssignmentsEditorSelectors.isCustomersLevelSelected,
    hierarchyAssignmentsEditorSelectors.isLoading,
    hierarchyAssignmentsEditorSelectors.areCustomersLoaded,
    (show, levelSelected, loading, loaded) => needMoreEntities(show, levelSelected, loading, loaded)
)

export const needMoreProjects = createSelector(
    showEditor,
    hierarchyAssignmentsEditorSelectors.isProjectsLevelSelected,
    hierarchyAssignmentsEditorSelectors.isLoading,
    hierarchyAssignmentsEditorSelectors.areProjectsLoaded,
    (show, levelSelected, loading, loaded) => needMoreEntities(show, levelSelected, loading, loaded)
)

export const needMoreTasks = createSelector(
    showEditor,
    hierarchyAssignmentsEditorSelectors.isTasksLevelSelected,
    hierarchyAssignmentsEditorSelectors.isLoading,
    hierarchyAssignmentsEditorSelectors.areTasksLoaded,
    (show, levelSelected, loading, loaded) => needMoreEntities(show, levelSelected, loading, loaded)
)

export const getEditingLevel = hierarchyAssignmentsEditorSelectors.getEditingLevel

export const getCustomerIdsOrder = hierarchyAssignmentsEditorSelectors.getCustomerIdsOrder

export const getProjectIdsOrder = hierarchyAssignmentsEditorSelectors.getProjectIdsOrder

export const getTaskIdsOrder = hierarchyAssignmentsEditorSelectors.getTaskIdsOrder

export const areFutureCustomersAssigned = hierarchyAssignmentsEditorSelectors.areFutureCustomersAssigned

export const areFutureProjectsAssigned = hierarchyAssignmentsEditorSelectors.areFutureProjectsAssigned

export const areFutureTasksAssigned = hierarchyAssignmentsEditorSelectors.areFutureTasksAssigned

export const getCanWorkCustomerIds = hierarchyAssignmentsEditorSelectors.getCanWorkCustomerIds

export const getCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerIds

export const getCanManageCustomerExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerExcludeSelfIds

export const getCanWorkProjectIds = hierarchyAssignmentsEditorSelectors.getCanWorkProjectIds

export const getCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectIds

export const getCanManageProjectExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectExcludeSelfIds

export const getCanWorkTaskIds = hierarchyAssignmentsEditorSelectors.getCanWorkTaskIds

export const getCanManageTaskIds = hierarchyAssignmentsEditorSelectors.getCanManageTaskIds

export const getProjectCountsByCustomers = hierarchyAssignmentsEditorSelectors.getProjectCountsByCustomers

export const getTaskCountsByCustomers = hierarchyAssignmentsEditorSelectors.getTaskCountsByCustomers

export const getTaskCountsByProjects = hierarchyAssignmentsEditorSelectors.getTaskCountsByProjects

export const areSomeCustomersOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeCustomersOrLowerAssigned

export const areAllCustomersAssigned = hierarchyAssignmentsEditorSelectors.areAllCustomersAssigned

export const areSomeProjectsOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeProjectsOrLowerAssigned

export const areAllProjectsAssigned = hierarchyAssignmentsEditorSelectors.areAllProjectsAssigned

export const areSomeTasksAssigned = hierarchyAssignmentsEditorSelectors.areSomeTasksAssigned

export const areAllTasksAssigned = hierarchyAssignmentsEditorSelectors.areAllTasksAssigned

export const isLoading = hierarchyAssignmentsEditorSelectors.isLoading

export const getChangingCustomerAssignments = hierarchyAssignmentsEditorSelectors.getChangingCustomerAssignments

export const getChangingProjectAssignments = hierarchyAssignmentsEditorSelectors.getChangingProjectAssignments

export const getChangingTaskAssignments = hierarchyAssignmentsEditorSelectors.getChangingTaskAssignments

export const getCustomersSearchOpen = hierarchyAssignmentsEditorSelectors.getCustomersSearchOpen

export const getCustomersSearchText = hierarchyAssignmentsEditorSelectors.getCustomersSearchText

export const getProjectsSearchOpen = hierarchyAssignmentsEditorSelectors.getProjectsSearchOpen

export const getProjectsSearchText = hierarchyAssignmentsEditorSelectors.getProjectsSearchText

export const getTasksSearchOpen = hierarchyAssignmentsEditorSelectors.getTasksSearchOpen

export const getTasksSearchText = hierarchyAssignmentsEditorSelectors.getTasksSearchText

export const getViewerCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageCustomerIds

export const getViewerCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageProjectIds

export const showOnlyActiveEntities = state => getManagementAssignmentsEditorState(state).onlyActiveEntities

export const canManageParentCustomer = hierarchyAssignmentsEditorSelectors.canManageParentCustomer

export const canManageParentProject = hierarchyAssignmentsEditorSelectors.canManageParentProject

export const getEditingUser = getFullUserInfo

export const getSelectedCustomer = createSelector(
    EntitiesSelectors.getCustomers,
    getEditingLevel,
    (customers, {customerId}) => customerId !== null ? customers[customerId] : null
)

export const getSelectedProject = createSelector(
    EntitiesSelectors.getProjects,
    getEditingLevel,
    (projects, {projectId}) => projectId !== null ? projects[projectId] : null
)

export const getCustomers = createSelector(
    EntitiesSelectors.getCustomers,
    getCustomerIdsOrder,
    (customers, customerIdsOrder) => customerIdsOrder.map(id => customers[id])
)

export const getProjects = createSelector(
    EntitiesSelectors.getProjects,
    getProjectIdsOrder,
    (projects, projectIdsOrder) => projectIdsOrder.map(id => projects[id])
)

export const getTasks = createSelector(
    EntitiesSelectors.getTasks,
    getTaskIdsOrder,
    (tasks, taskIdsOrder) => taskIdsOrder.map(id => tasks[id])
)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createUserManagementAssignmentsEditor/selectors.js